export default __webpack_public_path__ + "static/media/DSS_HeroBanner_675x300_Build-and-Construction_Final.fc6008eb.gif";